import company from './company';
import contact from './contact';
import project from './project';
import eproject from './eproject';
import search from './search';
import approval from './approval';
import { reverseSortingOrder } from './sortingOrder';

export default {
  company,
  contact,
  project,
  eproject,
  search,
  approval,
  reverseSortingOrder,
};
